import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-error-accordion",
  templateUrl: "./error-accordion.component.html",
  styleUrl: "./error-accordion.component.scss",
})
export class ErrorAccordionComponent {
  @Input() errorObject: any = {};
  @Output() highlightObject = new EventEmitter<any>();
  activeIndex: number = 0;
  errorTypes = [
    "shelfOverflow",
    "shelfStacking",
    "floatingFixtures",
    "shelfLabelDuplicate",
    "doorLabelDuplicate",
    "doorOverlap",
    "productOverflow",
    "noImageProduct"
  ];
  errorAccordions: any = [];
  constructor(public cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.errorTypes.forEach((type: any) => {
      if (this.errorObject[type].count > 0) {
        this.errorAccordions.push(type);
      }
    });
    // Open the first accordion by default
    this.activeIndex = 0;
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.errorObject) {
      this.errorObject = changes.errorObject.currentValue;
    }
  }

  ngDoCheck() {
    // Check if errorObject has changed
    if (this.errorObject) {
      this.errorAccordions = [];
      this.errorTypes.forEach((type: any) => {
        if (this.errorObject[type].count > 0) {
          this.errorAccordions.push(type);
        }
      });
    }
  }

  highLightError(error: any, isBlink: boolean = false, type: any) {
    let object;
    if (type == "shelfOverflow" || type == "shelfStacking" || type == "floatingFixtures" || type == "shelfLabelDuplicate" || type == "doorLabelDuplicate" || type == "doorOverlap") {
      object = error?.objectList?.length ? error.objectList : (error.currentShelf || error.sku);
    } else {
      object = error?.objectList?.length ? error.objectList : error.sku;
    }
    this.highlightObject.emit({
      object: object,
      multiple: error?.objectList?.length ? true : false,
      isBlink: isBlink,
    });
  }

  ngOnDestroy(): void {
    this.activeIndex = 0; // reset accordion open state
  }
}
